import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getSapStatus = (payload) => {
  return axios
    .get(`${URL_ORI}/api/SAPUpdateStatus/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getSapStatusGenerateAll = (payload) => {
  return axios
    .get(`${URL_ORI}/api/SAPUpdateStatus/GenerateAll`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};


export const createSapStatus= (payload) => {
  return axios.post(`${URL_ORI}/api/SAPUpdateStatus`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
